export const safelyCollapseSelectionToEnd = () => {
	const selection = window.getSelection();

	if (!selection || selection.rangeCount === 0) {
		return;
	}

	try {
		selection.collapseToEnd();
	} catch (error) {
		// Safari/iOS can expose a stale Selection after editor updates.
		if (!(error instanceof DOMException) || error.name !== 'InvalidStateError') {
			throw error;
		}
	}
};
